var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "verticalCenter" }, [
    _vm.$store.state.forum.articleData &&
    _vm.$store.state.forum.articleData.length > 0
      ? _c(
          "div",
          [
            _vm._l(_vm.$store.state.forum.articleData, function(item) {
              return _c(
                "div",
                {
                  key: item.id,
                  staticClass: "forumBlock",
                  attrs: { id: item.id },
                  on: { click: _vm.forumBlockClick }
                },
                [
                  _c(
                    "div",
                    { staticClass: "forumArticle" },
                    [
                      _c(
                        "div",
                        { staticClass: "forumAuthor" },
                        [
                          item.category
                            ? _c(
                                "base-button",
                                {
                                  staticClass: "tag-style-left",
                                  style: {
                                    "background-color":
                                      item.category.color + " !important",
                                    "border-color":
                                      item.category.color + " !important"
                                  }
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        item.category[
                                          _vm.normalizeForumProp("name")
                                        ]
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            [
                              _vm._v(
                                "\r\n                    " +
                                  _vm._s(_vm.$t("publishedBy")) +
                                  "\r\n                    "
                              ),
                              item.userPage
                                ? _c(
                                    "a",
                                    {
                                      staticClass: "underlined bold",
                                      attrs: {
                                        target: "_blank",
                                        href: item.userPage
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(item.authorName))]
                                  )
                                : _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(item.authorName)
                                    }
                                  }),
                              _vm._v(" "),
                              item.userSpeciality
                                ? _c("span", [
                                    _vm._v("\r\n                      ("),
                                    item.userPage
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "underlined bold",
                                            attrs: {
                                              target: "_blank",
                                              href: item.userPage
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("consultationIn")) +
                                                " "
                                            ),
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.userSpeciality[
                                                    _vm.normalizeForumProp(
                                                      "name"
                                                    )
                                                  ]
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(")\r\n                    ")
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.disease
                                ? _c(
                                    "base-button",
                                    { staticClass: "tag-style-right" },
                                    [
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            item.disease[
                                              _vm.normalizeForumProp("name")
                                            ]
                                          )
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          item.lastInteractionDate
                            ? _c(
                                "div",
                                { staticStyle: { "font-size": "8px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("lastInteraction")) + " "
                                  ),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.getTimeAgoFromDate(
                                          item.lastInteractionDate
                                        )
                                      )
                                    }
                                  })
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      item.category
                        ? _c(
                            "base-button",
                            {
                              staticClass: "tag-style-mobile",
                              style: {
                                "background-color":
                                  item.category.color + " !important",
                                "border-color":
                                  item.category.color + " !important"
                              }
                            },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.category[
                                      _vm.normalizeForumProp("name")
                                    ]
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.disease
                        ? _c(
                            "base-button",
                            { staticClass: "tag-style-mobile-disease" },
                            [
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.disease[_vm.normalizeForumProp("name")]
                                  )
                                }
                              })
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      item.title
                        ? _c("h3", {
                            staticClass: "forumArticleTitle",
                            domProps: { innerHTML: _vm._s(item.title) }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.articlePicture && _vm.showImage
                        ? _c("img", {
                            staticClass: "forumImageSize",
                            attrs: { src: item.articlePicture }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.whoInData
                        ? _c("div", { staticClass: "activity-block" }, [
                            _c("img", {
                              staticClass: "activity-picture",
                              attrs: {
                                alt: "",
                                src: _vm.getActivitityPicture(item.whoInData)
                              }
                            }),
                            _vm._v(" "),
                            _c("div", { staticClass: "activity-content" }, [
                              _c(
                                "div",
                                { staticClass: "activity-name-block" },
                                [
                                  _c("base-button", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getActivityName(item.whoInData)
                                      )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.activityIsFull(item.whoInData)
                                    ? _c(
                                        "base-button",
                                        { attrs: { red: "" } },
                                        [_vm._v(_vm._s(_vm.$t("closed")))]
                                      )
                                    : _c(
                                        "base-button",
                                        {
                                          attrs: {
                                            textColor: _vm.BLACK_COLOUR,
                                            borderColor: _vm.GREEN_COLOUR,
                                            backgroundColor: _vm.GREEN_COLOUR
                                          }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("open")))]
                                      )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("p", {
                                staticClass:
                                  "forumDescription whoInDescription",
                                class: {
                                  "hide-forum-description-mobile":
                                    _vm.hideForumDescription
                                },
                                attrs: { id: "whoInDescription-" + item.id },
                                domProps: {
                                  innerHTML: _vm._s(
                                    item.description ||
                                      (_vm.showFullWhoInDescription
                                        ? _vm.getWhoInDescription(
                                            item.whoInData
                                          )
                                        : _vm.getWhoInDescriptionShort(
                                            item.whoInData
                                          ))
                                  )
                                }
                              })
                            ])
                          ])
                        : _c("p", {
                            staticClass: "forumDescription",
                            class: {
                              "hide-forum-description-mobile":
                                _vm.hideForumDescription
                            },
                            domProps: { innerHTML: _vm._s(item.description) }
                          }),
                      _vm._v(" "),
                      !_vm.hideFooter
                        ? _c(
                            "div",
                            [
                              item.whoInData
                                ? _c(
                                    "b-row",
                                    { staticClass: "forumFooter" },
                                    [
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: {
                                            cols: _vm.showFullWhoInDescription
                                              ? 4
                                              : 3
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.toggleSignUpWhoIn(item)
                                            }
                                          }
                                        },
                                        [
                                          _vm.signedUpWhoInActivity(
                                            item.whoInData
                                          )
                                            ? _c("b-icon-person-check-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-person-check", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c("span", {
                                            staticClass: "hide-title-mobile",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getSignUpTitle(
                                                  item.whoInData
                                                ) + " "
                                              )
                                            }
                                          }),
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.getWhoInParticipants(
                                                  item.whoInData
                                                )
                                              )
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.showFullWhoInDescription
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.toggleWhoInDescription(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-info-circle", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      item.showingFullDetails
                                                        ? _vm.$t("hideDetails")
                                                        : _vm.$t("showDetails")
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      !_vm.showAnswerBtn
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("commentaries")
                                                    )
                                                  )
                                                ]
                                              ),
                                              item.totalMessages
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "hide-title-mobile"
                                                      },
                                                      [_vm._v(": ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opensalud-blue"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.totalMessages
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showEntryAnswerBlock.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("comment"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _vm.canEditForumEntry(item.id) ||
                                      _vm.canModifyForumEntry(item.id)
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3,
                                                id: "more-options-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-three-dots", {
                                                attrs: { scale: "1.5" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: _vm.showFullWhoInDescription
                                                  ? 4
                                                  : 3,
                                                id: "share-socials-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-share", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("share"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                                : _c(
                                    "b-row",
                                    { staticClass: "forumFooter" },
                                    [
                                      !_vm.showAnswerBtn
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("commentaries")
                                                    )
                                                  )
                                                ]
                                              ),
                                              item.totalMessages
                                                ? _c("span", [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "hide-title-mobile"
                                                      },
                                                      [_vm._v(": ")]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "opensalud-blue"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.totalMessages
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  ])
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: { cols: "3" },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.showEntryAnswerBlock.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-chat-left", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("answer"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "3" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.articleLike(item.id)
                                            }
                                          }
                                        },
                                        [
                                          _vm.$store.state.forum.userBasicInfo.entriesLike.includes(
                                            item.id
                                          )
                                            ? _c("b-icon-hand-thumbs-up-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-hand-thumbs-up", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hide-title-mobile"
                                            },
                                            [_vm._v(_vm._s(_vm.$t("like")))]
                                          ),
                                          item.likes
                                            ? _c("span", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "hide-title-mobile"
                                                  },
                                                  [_vm._v(": ")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "opensalud-blue"
                                                  },
                                                  [_vm._v(_vm._s(item.likes))]
                                                )
                                              ])
                                            : _vm._e()
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "b-col",
                                        {
                                          staticClass: "py-2",
                                          attrs: { cols: "3" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.saveArticle(item.id)
                                            }
                                          }
                                        },
                                        [
                                          _vm.$store.state.forum.userBasicInfo.entriesSaved.includes(
                                            item.id
                                          )
                                            ? _c("b-icon-bookmark-check-fill", {
                                                staticClass:
                                                  "opensalud-blue margin-right-icon"
                                              })
                                            : _c("b-icon-bookmark", {
                                                staticClass: "margin-right-icon"
                                              }),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "hide-title-mobile"
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$store.state.forum.userBasicInfo.entriesSaved.includes(
                                                    item.id
                                                  )
                                                    ? _vm.$t("saved")
                                                    : _vm.$t("save")
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm.canEditForumEntry(item.id) ||
                                      _vm.canModifyForumEntry(item.id)
                                        ? _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                id: "more-options-" + item.id,
                                                cols: "3"
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-three-dots", {
                                                attrs: { scale: "1.5" }
                                              })
                                            ],
                                            1
                                          )
                                        : _c(
                                            "b-col",
                                            {
                                              staticClass: "py-2",
                                              attrs: {
                                                cols: "3",
                                                id: "share-socials-" + item.id
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                }
                                              }
                                            },
                                            [
                                              _c("b-icon-share", {
                                                staticClass: "margin-right-icon"
                                              }),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "hide-title-mobile"
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$t("share"))
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                    ],
                                    1
                                  )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.showValidateEntry
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "2%" } },
                        [
                          _c(
                            "base-button",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.validateEntry(item.id, true)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("validate")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "base-button",
                            {
                              attrs: { red: "" },
                              on: {
                                click: function($event) {
                                  return _vm.validateEntry(item.id, false)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("reject")))]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("social-sharing-popover", {
                    attrs: {
                      url: _vm.shareArticleLink(item.id),
                      targetId: "share-socials-" + item.id,
                      sectionName: _vm.getForumSectionTitle(
                        _vm.$store.state.forum.sectionId,
                        true
                      )
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "b-popover",
                    {
                      attrs: {
                        target: "more-options-" + item.id,
                        triggers: "click",
                        placement: "top"
                      }
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "more-options-row" },
                        [
                          _c(
                            "b-col",
                            {
                              attrs: {
                                cols: "12",
                                id: "share-socials-popover-" + item.id
                              },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "more-options-item" },
                                [
                                  _c("b-icon-share", {
                                    staticClass: "margin-right-icon"
                                  }),
                                  _c(
                                    "span",
                                    { staticClass: "hide-title-mobile" },
                                    [_vm._v(_vm._s(_vm.$t("share")))]
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.canEditForumEntry(item.id)
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.updateEntry(item)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-pencil-square", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("edit")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.canModifyForumEntry(item.id)
                            ? _c(
                                "b-col",
                                {
                                  attrs: { cols: "12" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return function() {
                                        _vm.showConfirmDelete = true
                                        _vm.entryIdSelected = item.id
                                        _vm.$root.$emit("bv::hide::popover")
                                      }.apply(null, arguments)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "more-options-item" },
                                    [
                                      _c("b-icon-trash", {
                                        staticClass: "margin-right-icon"
                                      }),
                                      _c(
                                        "span",
                                        { staticClass: "hide-title-mobile" },
                                        [_vm._v(_vm._s(_vm.$t("remove")))]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("social-sharing-popover", {
                            attrs: {
                              url: _vm.shareArticleLink(item.id),
                              targetId: "share-socials-popover-" + item.id,
                              sectionName: _vm.getForumSectionTitle(
                                _vm.$store.state.forum.sectionId,
                                true
                              )
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }),
            _vm._v(" "),
            _c("base-dialog", {
              attrs: {
                value: _vm.showConfirmDelete,
                okFn: function() {
                  _vm.removeEntry()
                  _vm.showConfirmDelete = false
                },
                cancelFn: function() {
                  _vm.showConfirmDelete = false
                },
                okBtnText: _vm.$t("yes"),
                cancelBtnText: _vm.$t("no"),
                content: _vm.$t("removePostAdvice")
              }
            }),
            _vm._v(" "),
            _vm.showMorePostMessages && !_vm.hideFooter
              ? _c(
                  "div",
                  {
                    staticClass: "seeMoreEntries",
                    on: { click: _vm.loadMoreEntries }
                  },
                  [
                    _c("b-icon", {
                      staticClass: "pointer",
                      attrs: { icon: "arrow-down", scale: "0.7" }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "pointer" }, [
                      _vm._v(_vm._s(_vm.$t("showMoreEntries")))
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          2
        )
      : _c("div", { staticStyle: { "margin-top": "30vh" } }, [
          _vm.$store.state.forum.entrySearchValue
            ? _c("h1", [_vm._v(_vm._s(_vm.$t("emptyEntriesSearch")))])
            : _vm.inWhoInSection
            ? _c(
                "div",
                [
                  _c("h1", [_vm._v(_vm._s(_vm.$t("emptyActivitiesSearch")))]),
                  _vm._v(" "),
                  _c(
                    "base-button",
                    { staticClass: "mt-3", on: { click: _vm.createNewPost } },
                    [_vm._v(_vm._s(_vm.$t("proposeNewActivity")))]
                  )
                ],
                1
              )
            : _c("h1", [_vm._v(_vm._s(_vm.$t("emptyEntries")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a8b81d5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8b81d5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/healthy-community/forum/ForumArticleBlock.vue
// module id = 1729
// module chunks = 116